// Progressive enhancement: Service Worker 未対応環境では何もしない。

export const UPDATE_EVENT = "firmee:pwa-update-ready"
export const STATUS_EVENT = "firmee:pwa-status"

function publishStatus(detail) {
  window.dispatchEvent(new CustomEvent(STATUS_EVENT, { detail }))
}

function publishUpdateReady(registration) {
  window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: { registration } }))
}

function watchWorker(worker, registration) {
  if (!worker) return
  worker.addEventListener("statechange", () => {
    if (worker.state === "installed" && navigator.serviceWorker.controller) {
      publishUpdateReady(registration)
      publishStatus({ state: "update-ready" })
    }
  })
}

export function registerServiceWorker() {
  if (!navigator.serviceWorker || typeof navigator.serviceWorker.register !== "function") {
    publishStatus({ state: "unsupported" })
    return Promise.resolve(null)
  }

  const start = () =>
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((registration) => {
        publishStatus({ state: "registered", scope: registration.scope })
        if (registration.waiting && navigator.serviceWorker.controller) {
          publishUpdateReady(registration)
          publishStatus({ state: "update-ready" })
        }
        registration.addEventListener("updatefound", () => {
          watchWorker(registration.installing, registration)
        })
        return registration
      })
      .catch((error) => {
        console.warn("[firmee-pwa] service worker registration failed", error)
        publishStatus({ state: "registration-failed" })
        return null
      })

  if (document.readyState === "complete") {
    return start()
  }

  return new Promise((resolve) => {
    window.addEventListener(
      "load",
      () => {
        start().then(resolve)
      },
      { once: true }
    )
  })
}

export function requestSkipWaiting(registration) {
  const worker = registration?.waiting
  if (!worker) return
  worker.postMessage({ type: "SKIP_WAITING" })
}
